"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingStorageProperties = void 0;
var SettingStorageProperties;
(function (SettingStorageProperties) {
    SettingStorageProperties["View"] = "view";
})(SettingStorageProperties = exports.SettingStorageProperties || (exports.SettingStorageProperties = {}));
//# sourceMappingURL=setting-storage-properties.js.map